import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ErrorBoundary } from '@/ui/error-boundary';

import { AuthProvider } from './providers/AuthProvider';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { router } from './routes';

export function App() {
    return (
        <ErrorBoundary>
            <QueryProvider>
                <ThemeProvider>
                    <AuthProvider>
                        <RouterProvider router={router} />
                        <Toaster
                            position="bottom-right"
                            toastOptions={{
                                classNames: {
                                    toast: 'group toast border border-border bg-card text-foreground shadow-lg',
                                    description: 'text-muted-foreground',
                                    actionButton: 'bg-terracotta text-terracotta-foreground',
                                },
                            }}
                        />
                    </AuthProvider>
                </ThemeProvider>
            </QueryProvider>
        </ErrorBoundary>
    );
}
